import { IRouteType } from '../../types'
import ghaiPopCorporateIntraday from './ghaiPopCorporateIntraday'
import ghaiPopFlash from './ghaiPopFlash'
import ghaiPopHome from './ghaiPopHome'
import ghaiPopLateNightReport from './ghaiPopLateNightReport'
import ghaiPopProduct from './ghaiPopProduct'

export const routes: IRouteType[] = [
  {
    title: 'Corporate',
    children: [
      {
        title: 'Flash',
        link: '/:brand/flash',
      },
      // Same as Hourly Sales
      // {
      //   title: 'Late Night Report',
      //   link: '/:brand/late-night-report',
      // },
      {
        title: 'Hourly Sales',
        link: '/:brand/hourly_sales',
      },
      {
        title: 'Product',
        link: '/:brand/product',
      },
    ],
  },
  {
    title: 'Store',
    children: [
      {
        title: 'Home',
        link: '/:brand/scorecard',
      },
    ],
  },
]

export default [
  ghaiPopFlash,
  ghaiPopHome,
  ghaiPopLateNightReport,
  ghaiPopProduct,
  ghaiPopCorporateIntraday,
]
